<template>
  <div class="social-form">
    <el-form :inline="true"
             :model="searchForm"
             class="demo-form-inline">
      <el-form-item label="产品">
        <el-select v-model="searchForm.product"
                   placeholder="请选择产品"
                   size="mini"
                   class="w120">
          <el-option v-for="item in productList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="平台">
        <el-select v-model="searchForm.plat"
                   multiple
                   collapse-tags
                   placeholder="不限"
                   size="mini"
                   class="w170">
          <el-option v-for="item in platList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="类目">
        <el-input placeholder="请输入类目关键词"
                  v-model="searchForm.cat_name"
                  size="mini"
                  class="w200" />
      </el-form-item>
      <el-form-item label="关键词">
        <el-input placeholder="在自定义分析名称或规则中搜索"
                  v-model="searchForm.q"
                  size="mini"
                  class="w200" />
      </el-form-item>
      <el-form-item label="类型">
        <el-select v-model="searchForm.custom_typ"
                   size="mini"
                   class="w170">
          <el-option v-for="item in typeList"
                     :key="item.value"
                     :label="item.label"
                     :value="item.value" />
        </el-select>
      </el-form-item>
      <el-form-item class="submitFormItem">
        <el-col style="text-align:right;">
          <el-button type="primary"
                     size="mini"
                     @click="onSubmit">查询</el-button>
        </el-col>
      </el-form-item>
    </el-form>
  </div>
</template>


<script>
export default {
  data() {
    return {
      searchForm: {
        product: '', //产品
        plat: '',
        cat_name: '',
        q: '',
        custom_typ: 'all',
      },
      productList: [
        { value: '', label: '不限' },
        { value: 'fenxiplus', label: '分析+' },
        { value: 'comment', label: '电商聆听' },
        { value: 'sociales', label: '社交聆听' },
        { value: 'oversea', label: 'oversea' },
      ],
      platList: [
        { value: 'cshop', label: '淘宝' },
        { value: 'tmall', label: '天猫' },
        { value: 'jd', label: '京东' },
        { value: 'douyin', label: '抖音' },
        { value: 'amazon', label: '亚马逊' },
        { value: 'shopee', label: 'shopee' },
        { value: 'lazada', label: 'lazada' },
      ],
      typeList: [
        { value: 'all', label: '全部' },
        { value: 'ai', label: 'AI自动建模' },
      ],
    }
  },
  props: {},
  computed: {
    formObj() {
      let platList = []
      if (this.searchForm.plat !== '') {
        platList = this.searchForm.plat
          .map((element) => {
            return element
          })
          .join(',')
      }
      let searchForm = {
        product: this.searchForm.product,
        plat: this.searchForm.plat == '' ? this.searchForm.plat : platList,
        cat_name: this.searchForm.cat_name,
        custom_typ: this.searchForm.custom_typ,
        q: this.searchForm.q,
        page: this.currentPage,
        page_size: this.currentSize,
      }
      let obj = {
        ...searchForm,
      }
      return obj
    },
  },
  methods: {
    onSubmit() {
      this.$emit('formChange', this.formObj)
    },
    formChange() {
      this.$emit('formChange', this.formObj)
    },
  },
  created() {
    this.formChange()
  },
}
</script>

<style lang="less" scoped>
.social-form {
  .demo-form-inline {
    .w200 {
      width: 200px;
    }
    .w120 {
      width: 120px;
    }
    .w170 {
      width: 170px;
    }
    .w80 {
      width: 80px;
    }
    .w100 {
      width: 100px;
    }
    .w220 {
      width: 220px;
    }
    .submitFormItem {
      float: right;
      .el-button {
        background-color: #3a63f3;
        border-color: #ffffff;
        color: #ffffff;
      }
    }
  }
}
</style>